<template>
  <div class="public-container">
    <error
      v-if="apiDown"
      error-type="expired"
      :message="'This link has expired'"
    ></error>
    <public-page
      v-if="!apiDown && publicInfo"
      :publicInfo="publicInfo"
      :displayButtons="displayButtons"
    ></public-page>
  </div>
</template>

<script>
import store from '@/store';
import { mapState } from 'vuex';
import Error from '@/components/generic/errorComponent.vue';
import PublicPage from '@/components/shared/publicPage.vue';
import settings from '@/settings';
import Axios from 'axios';

export default {
  components: {
    Error,
    PublicPage,
  },
  data() {
    return {
      displayButtons: false,
    };
  },
  computed: {
    ...mapState('code', ['publicInfo', 'apiDown']),
  },
  async beforeRouteEnter(to, from, next) {
    const orgId = to.params && to.params.orgId ? to.params.orgId : null;
    let brokenLinks = null;
    try {
      const brokenLinksFile = settings.brokenLinks.replace(
        /{orgId}/g,
        String(orgId),
      );

      brokenLinks = (await Axios.get(brokenLinksFile)).data;
    } catch (error) {
      brokenLinks = null;
    }

    const wrongPaths = brokenLinks ? Object.keys(brokenLinks) : [];
    if (wrongPaths.includes(to.path)) {
      next(brokenLinks[to.path]);
    } else {
      next((vm) => {
        vm.displayButtons = to.params.channel !== 'wechat';
        store
          .dispatch('code/setPublicInfo', {
            organizationId: to.params.orgId,
            interactionId: to.params.interactionId,
          })
          .then(() => {
            store.dispatch('core/enableGDPR', true);
          });
      });
    }
  },
  beforeRouteUpdate(to, from, next) {
    this.displayButtons = to.params.channel !== 'wechat';
    if (to.path !== from.path) {
      store
        .dispatch('code/setPublicInfo', {
          organizationId: to.params.orgId,
          interactionId: to.params.interactionId,
        })
        .then(() => {
          store.dispatch('core/enableGDPR', true);
        });
    }
    next();
  },
};
</script>

<style lang="scss" scoped>
.public-container {
  max-width: 800px;
  margin: 0 auto;
  background-color: white;
}
</style>
